import {enter, leave} from 'el-transition';

/**
 *
 * @constructor
 */
export function Modal()
{
    // watch for close action
    action(document.querySelectorAll('[data-modal-close]'));

    // watch for open action
    action(document.querySelectorAll('[data-js-button="modal"]'));

}

/**
 * Initiate the transition
 * @param modal
 */
function transition(modal)
{
    if (modal.classList.contains('hidden')) {
        enter(modal);
        fixed();
    } else {
        // add the 'js-user-closed' class to avoid the open on scroll from reopening.
        // modal.setAttribute('class', 'js-user-closed');
        leave(modal);
        fixed();
    }
}



/**
 * Loop through each.
 * Get the target #id, use transition
 * @param data
 */
function action(data)
{
    if (data && data.length > 0) {
        Array.from(data).map(clicker => clicker.addEventListener('click', (e) => {
            const data = clicker.dataset;
            const target = data.jsTarget;
            const modal = document.getElementById(target);
            transition(modal);
        }));
    }
}

function fixed()
{
    document.body.classList.toggle('overflow-hidden');
}



// WEBPACK FOOTER //
// ./scripts/Modules/Modal.js